import {Dog} from "./dog";
import {User} from "./user";

export class Note {
    id: string;
    start: Date;
    end: Date;
    notes: string;
    resolved: boolean;
    dogId: string;
    dog: Dog;
    userId: string;
    user: User;
}



// WEBPACK FOOTER //
// ./src/classes/note.ts